export const styles = {
  icon: 'w-2xl h-2xl rounded-md',
  codeWrapper:
    'min-h-[4.8rem] p-sm rounded-md bg-neutral10 border border-neutral20',
  code: 'leading-none overflow-hidden text-ellipsis',
  codeBtn: 'flex-1',
};
